import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Amount from "@material-ui/icons/AccountBalanceWalletTwoTone";
import Token from "@material-ui/icons/AssignmentTurnedIn";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import AirlinesPaymentTable from "./AirlinesTable.jsx";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import AirlinePaymentPanel from "./AirlinePaymentPanel";
import { store } from "../../_store";
import { alertActions, commonActions } from "../../_actions";
import { EmptyRecord } from "../../utils/PageUtility";
import { commonService } from "../../_services";
import { appConstants } from "../../_constants";
import CircularProgress from '../../utils/CircularProgress';
import { appHelpers } from "../../_helpers";
import moment from "moment";

import DownloadIcon from "@material-ui/icons/CloudDownload";


const today = new Date();
let yesterday = new Date();
yesterday.setDate(today.getDate() - 30);

class AirlinesList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            airlines: [],
            name: "hai",
            airlineName: "",
            paymentData: [],
            AirlineId: '-1',
            startDate: yesterday,
            endDate: new Date(),
            isProgressActive: true,
            airlinePayments: false,
            testName: "",
            totalTokenAmount: 0,
            totalTokenPurchased: 0,
            dataCount: 0,
            currentPage: 1,
            pageSize: 10,
            totalPaymentCount: 0,
            requestingPayments: true,
            airportLocation: "-1",
            locationData: []
        };
    }

    handleDateChange = (date, target) => {
        this.setState({ [target]: date });
    };

    handleAirlineChange = prop => event => {
        this.setState({ [prop]: event.target.value });
    };

    componentDidMount() {
        //vvv
        let { airlines, user, airports } = store.getState();
        const { startDate, endDate, pageSize } = this.state;

        const { dispatch } = this.props;

        if (airlines) {
            this.setState({ airlines: airlines });
        } else {
            dispatch(commonActions.getAllAirlines());
        }

        if (airports) {
            this.setState({ locationData: airports })
        } else {
            dispatch(commonActions.getAllAirports())
        }

        /*Check type of user*/
        if (user.AppRole === appConstants.ROLES.AIRLINE) {
            let userObj = {...user};
            let userAirline = {value: userObj.AirlineId, label: userObj.AirlineName};
            this.setState({ AirlineId: userAirline });
            let payload = {
                StartDate: moment(startDate).format('YYYY-MM-DD') + "T00:00:00",
                EndDate: moment(endDate).format('YYYY-MM-DD') + "T23:59:59",
                AirlineId: user.AirlineId,
                from: 1,
                size: pageSize,
            };
            this.searchAirlinePayment(1, payload);
        } else if (user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) {
            let userObj = {...user};
            let userLocation = {value: userObj.AirportCode, label: userObj.Location};
            this.setState({ airportLocation: userLocation });
            let payload = {
                StartDate: moment(startDate).format('YYYY-MM-DD') + "T00:00:00",
                EndDate: moment(endDate).format('YYYY-MM-DD') + "T23:59:59",
                AirportCode: user.AirportCode,
                from: 1,
                size: pageSize,
            };
            this.searchAirlinePayment(1, payload);
        } else if (user.Location) { //Check if location is mapped to user. That means its an outstation user
            let userObj = {...user};
            let userLocation = {value: userObj.AirportCode, label: userObj.Location};
            this.setState({ airportLocation: userLocation });
            let payload = {
                StartDate: moment(startDate).format('YYYY-MM-DD') + "T00:00:00",
                EndDate: moment(endDate).format('YYYY-MM-DD') + "T23:59:59",
                AirportCode: user.AirportCode,
                from: 1,
                size: pageSize,
            };
            this.searchAirlinePayment(1, payload);
        } else {
            this.searchAirlinePayment(1);
        }
    }

    componentWillReceiveProps = function (nextProps) {
        const { airlines, airports } = nextProps;
        if (airlines) {
            let modifiedAirlines = [...airlines];
            let allAirlines = { Airline: "All Airlines", AirlineId: "-1" };
            modifiedAirlines.unshift(allAirlines);
            this.setState({ airlines: modifiedAirlines });
        }
        if (airports) {
            let modifiedAirports = [...airports];
            modifiedAirports.unshift({ Name: "All Airports", airportLocation: "-1" });
            this.setState({ locationData: modifiedAirports })
        }
    };


    handleSelectChange = prop => event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleReactSelectChange = (value, name) => {
        this.setState({ [name.name]: value });
        if (value.value === undefined || value.value === "-1" || value.value === "All Flights"){
            this.setState({[name.name]: "-1"} )
        }
    };

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    //HANDLER TO SEARCH FOR INDIVIDUAL AIRLINE PAYMENT
    searchAirlinePayment = (pageNumber = 1, payload) => {

        const { AirlineId, startDate, endDate, pageSize, airportLocation } = this.state;
        const { dispatch } = this.props;

        if (!payload) {
            payload = {
                StartDate: moment(startDate).format('YYYY-MM-DD') + "T00:00:00",
                EndDate: moment(endDate).format('YYYY-MM-DD') + "T23:59:59",
                from: pageNumber,
                size: pageSize,
            };
            if (AirlineId !== '-1') {
                payload.AirlineId = AirlineId.value;
            }
            if (airportLocation !== '-1') {
                payload.AirportCode = airportLocation.value
            }
        }

        dispatch(alertActions.startRequest());
        commonService.searchAirlinePayment(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({ currentPage: pageNumber, totalPaymentCount: response.ResponseType.Count, paymentData: response.ResponseType.Details, totalTokenAmount: response.ResponseType.TotalTokenAmount, totalTokenPurchased: response.ResponseType.TotalTokensPurchased, requestingPayments: false })
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    if (typeof response === "string") {
                        dispatch(alertActions.error(response))
                    } else {
                        dispatch(alertActions.error(response.ErrorMessageList.join(', ')));
                    }
                    this.setState({ requestingPayments: false });
                }
            })
    };

    //HANDLER TO DOWNLOAD PAYMENT HISTORY
    downloadPaymentHistory = (type) => {

        const { AirlineId, airportLocation, startDate, endDate } = this.state;
        const { dispatch } = this.props;

        let payload = {
            StartDate: moment(startDate).format('YYYY-MM-DD') + "T00:00:00",
            EndDate: moment(endDate).format('YYYY-MM-DD') + "T23:59:59",
            Type: type
        };
        if (AirlineId !== '-1') {
            payload.AirlineId = AirlineId.value;
        }
        if (airportLocation !== '-1') {
            payload.AirportCode = airportLocation.value;
        }

        dispatch(alertActions.startRequest());
        commonService.downloadAirlinePayment(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    if (response.ResponseType === null) {
                        dispatch(alertActions.error(res.response.ErrorMessageList.join(', ')));
                        this.setState({ requestingPayments: false });
                    } else {
                        appHelpers.downloadFile(response.ResponseType.DownloadUrl, "Airline Payment Report");
                    }
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    if (typeof response === "string") {
                        dispatch(alertActions.error(response))
                    } else {
                        dispatch(alertActions.error(res.response.ErrorMessageList.join(', ')));
                    }
                    this.setState({ requestingPayments: false });
                }
            })
    };

    render() {
        const { classes, requesting, user } = this.props;
        const { airlines, paymentData, AirlineId, airlineName, startDate, endDate, currentPage, pageSize,
            totalPaymentCount, totalTokenAmount, totalTokenPurchased, requestingPayments, airportLocation,
            locationData } = this.state;

        if (requestingPayments)
            return (
                <CircularProgress />
            );
        return (
            <div>
                <AirlinePaymentPanel
                    user={this.props.user}
                    airline={airlineName}
                    AirlineId={(this.props.user.AppRole === appConstants.ROLES.AIRLINE ? AirlineId : AirlineId.value)}
                    selectChange={(e, name) => this.handleReactSelectChange(e, name)}
                    // selectChange={this.handleSelectChange("airlines")}
                    data={airlines}
                    onSearch={() => this.searchAirlinePayment()}
                    startDate={startDate}
                    endDate={endDate}
                    startLabel='Start Date'
                    endLabel='End Date'
                    handleDateChange={this.handleDateChange}
                    handleEndDateChange={this.handleDateChange}
                    airportLocation={(this.props.user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (user.Location) ? airportLocation : airportLocation.value}
                    locationData={locationData}
                />
                <GridContainer>
                    <GridItem xs={12} sm={6} md={6}>
                        <Card>
                            <CardHeader color="danger" stats icon>
                                <CardIcon color="danger">
                                    <Amount />
                                </CardIcon>
                                <p className={classes.cardCategory}>Total Token Amount</p>
                                <h3 className={classes.cardTitle}>&#8358;{appHelpers.numberWithCommas(totalTokenAmount)}</h3>
                            </CardHeader>
                            <CardFooter chart />
                        </Card>
                    </GridItem>

                    <GridItem xs={12} sm={6} md={6}>
                        <Card>
                            <CardHeader color="warning" stats icon>
                                <CardIcon color="warning">
                                    <Token />
                                </CardIcon>
                                <p className={classes.cardCategory}> Total Tokens Purchased</p>
                                <h3 className={classes.cardTitle}>{appHelpers.numberWithCommasOnly(totalTokenPurchased)}</h3>
                            </CardHeader>
                            <CardFooter chart />
                        </Card>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="success">
                                <h4 className={classes.cardTitleWhite}>Payments History</h4>
                                <p className={classes.cardCategoryWhite}>
                                    Here is a table for all airline payments
                          </p>
                            </CardHeader>
                            <CardBody>
                                {
                                    !requestingPayments && totalPaymentCount !== 0
                                    &&
                                    <AirlinesPaymentTable airlinesPaymentsData={paymentData} currentPage={currentPage}
                                        pageSize={pageSize} fetchPayments={this.searchAirlinePayment}
                                        totalPaymentCount={totalPaymentCount} />
                                }
                                {
                                    totalPaymentCount === 0
                                    &&
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <EmptyRecord message={'No Payment record'} />
                                        </GridItem>
                                    </GridContainer>
                                }
                            </CardBody>
                            {
                                totalPaymentCount !== 0
                                &&
                                <CardFooter chart>
                                    <div>
                                        <Button type="button" color="info" onClick={() => this.downloadPaymentHistory('pdf')} disabled={requesting}>
                                            <DownloadIcon />
                                            Download PDF
                                        </Button>
                                        <Button type="button" color="primary" onClick={() => this.downloadPaymentHistory('excel')} disabled={requesting}>
                                            <DownloadIcon />
                                            Download EXCEL
                                        </Button>
                                    </div>
                                </CardFooter>
                            }
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const { alert, airlines, progress, airlinesPayments, user, airports, requesting } = state;
    return {
        user,
        alert,
        airlines,
        progress,
        airlinesPayments,
        airports,
        requesting
    };
}
export default connect(mapStateToProps)(withMobileDialog()(withStyles(dashboardStyle)(AirlinesList)));



// WEBPACK FOOTER //
// ./src/views/AirlinePayment/Index.jsx